import React, {Component} from 'react'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Grid from '@mui/material/Grid'
import { Alert, AlertTitle, Box, Collapse, Paper, Snackbar, Typography } from '@mui/material'

const {DateTime} = require('luxon')
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class TicketPage extends Component{

    constructor(props) {
        super(props)

        var fechaInicioTemp = DateTime.local().set({hour: 0, minute: 0, second: 0})

        this.state = {

          txtEmpresa: "",
          txtCodigo: "",
          txtNombre: "",
          txtEmail: "",
          txtTelefono: "",
          Fecha: fechaInicioTemp,
          txtDescripcion: "",
          archivo: null,
          errores: {},

          mostrarAlerta: false,
          mensajeAlerta: '',
          severidadAlerta: 'info'
        }

    }

    handleCloseAlert= (event, reason) => {
        if (reason === 'clickaway') {
            return; // Evitar que se cierre si el usuario hace clic fuera
        }
        this.setState({ mostrarAlerta: false })
    }

    handleArchivoChange = (e) => {
        const archivo = e.target.files[0];
        const errores = { ...this.state.errores };
      
        if (archivo) {
          const extensionesPermitidas = ['jpg', 'jpeg', 'png', 'pdf', 'mp4', 'zip', 'rar'];
          const extension = archivo.name.split('.').pop().toLowerCase();
          const tamanoEnMB = archivo.size / (1024 * 1024); // convertir a MB
      
          if (!extensionesPermitidas.includes(extension)) {
            errores.archivo = 'Extensión no permitida. Usa: jpg, png, jpeg, pdf, mp4, zip, rar';
          } else if (tamanoEnMB > 100) {
            errores.archivo = 'El archivo supera el límite de 100MB.';
          } else {
            errores.archivo = ''; // No hay errores
          }
      
          this.setState({
            archivo: errores.archivo ? null : archivo,
            errores
          });
        }
    };

    validarCorreo(correo) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(correo);
    }

    btnAgregarTicketClick = () => {
        console.log('Agregando Ticket....')

        const errores = {};

        const empresa = this.state.txtEmpresa.trim();
        const codigoDepositario = this.state.txtCodigo.trim();
        const nombre = this.state.txtNombre.trim();
        const email = this.state.txtEmail.trim();
        const telefono = this.state.txtTelefono.trim();
        const fechaEvento = this.state.fechaEvento;
        const descripcion = this.state.txtDescripcion;
        const archivo = this.state.archivo;

        console.log("aqui estoy")

        if (!empresa) errores.empresa = "Debe ingresar el nombre de la empresa.";
        if (!codigoDepositario) errores.codigo = "Debe ingresar el código del depositario.";
        if (!nombre) errores.nombre = "Debe ingresar el nombre.";
        if (!email) {
            errores.email = 'Debe ingresar un correo electronico';
        } else if (!this.validarCorreo(email)) {
            errores.email = 'Por favor ingrese un correo valido';
        }
        if (!telefono) errores.telefono = "Debe ingresar el teléfono.";
        if (!fechaEvento) errores.fecha = "Debe ingresar la fecha del evento.";
        if (!descripcion) errores.descripcion = "Debe ingresar la descripción.";
        if (!archivo) errores.archivo = "Debe adjuntar un archivo";

        if (Object.keys(errores).length > 0) {
            this.setState({ errores });
            return;
        }

        this.setState({ errores: {} });

        const formData = new FormData();
        formData.append("empresa", empresa);
        formData.append("codigoDepositario", codigoDepositario);
        formData.append("nombre", nombre);
        formData.append("email", email);
        formData.append("telefono", telefono);
        formData.append("fechaEvento", fechaEvento.toFormat("yyyy-LL-dd HH:mm:ss"));
        formData.append("descripcion", descripcion);
        formData.append("archivo", archivo);

        const restArgs = {
            method: 'POST',
            body: formData,
            url: process.env.REACT_APP_URL_BACKEND + '/soporte/crearTicket'
        };

        RestTunel.makePetition(restArgs, (err, data) => {
            if (err) {
                this.setState({
                    mensajeError: data.message,
                    mostrarAlerta: true,
                    mensajeAlerta: 'Error: Se produjo un error creando el ticket.',
                    severidadAlerta: 'error'
                });
            } else {
                console.log(data)
                this.setState({                 
                    txtEmpresa: '',
                    txtCodigo: '',
                    txtNombre: '',
                    txtEmail: '',
                    txtTelefono: '',
                    fechaEvento: null,
                    txtDescripcion: '',
                    archivo: null,
                    errores: {},
                    mostrarAlerta: true,
                    mensajeAlerta: `Ticket #${data.id} registrado correctamente. Agradecemos tu reporte y estamos trabajando en una pronta solución.`,
                    severidadAlerta: 'success'
                });
            }
        });
    }

    render() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '100vh',
                backgroundColor: '#f9f9f9',
                px: 2,
            }}
        >
            {/* Logo */}
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 5, mb: 3 }}>
                <img alt="entidadLogo" src="/entidades/logo_selfia_classic.png" width={180} />
            </Box>

        
            <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ color: '#8CC63E', fontWeight: 'bold', mb: 3 }}
            >
                Crear Ticket
            </Typography>

            
            <Paper
                elevation={16}
                sx={{
                    p: 4,
                    borderRadius: 4,
                    backgroundColor: '#fefefe',
                    width: '100%',
                    maxWidth: '800px',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
                }}
            >
                <Card>
                    <CardContent>
                        <form>
                            <FormLabel sx={{ fontSize: '22px', fontWeight: 'bold', color: '#8CC63E', mb: 3 }}>
                                Información del ticket
                            </FormLabel>

                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                {/* Empresa */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Empresa"
                                        placeholder="Nombre de la empresa"
                                        variant="outlined"
                                        value={this.state.txtEmpresa}
                                        onChange={(e) => this.setState({ txtEmpresa: e.target.value })}
                                        error={!!this.state.errores.empresa}
                                        helperText={this.state.errores.empresa}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Código */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Código del depositario"
                                        placeholder="Código del depositario"
                                        variant="outlined"
                                        value={this.state.txtCodigo}
                                        onChange={(e) => this.setState({ txtCodigo: e.target.value })}
                                        error={!!this.state.errores.codigo}
                                        helperText={this.state.errores.codigo}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Nombre */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Nombre"
                                        placeholder="Nombre de quien reporta"
                                        variant="outlined"
                                        value={this.state.txtNombre}
                                        onChange={(e) => this.setState({ txtNombre: e.target.value })}
                                        error={!!this.state.errores.nombre}
                                        helperText={this.state.errores.nombre}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Correo */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Correo Electrónico"
                                        placeholder="Ingrese correo electrónico"
                                        type="email"
                                        variant="outlined"
                                        value={this.state.txtEmail}
                                        onChange={(e) => this.setState({ txtEmail: e.target.value })}
                                        error={!!this.state.errores.email}
                                        helperText={this.state.errores.email}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Teléfono */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Teléfono"
                                        placeholder="Ingrese el teléfono"
                                        variant="outlined"
                                        value={this.state.txtTelefono}
                                        onChange={(e) => this.setState({ txtTelefono: e.target.value })}
                                        error={!!this.state.errores.telefono}
                                        helperText={this.state.errores.telefono}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Fecha y hora */}
                                <Grid item xs={12}>
                                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                                        <DateTimePicker
                                            inputFormat="dd/MM/yyyy HH:mm"
                                            label="Fecha y hora del evento"
                                            value={this.state.fechaEvento}
                                            onChange={(newValue) => this.setState({ fechaEvento: newValue })}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    error={!!this.state.errores.fecha}
                                                    helperText={this.state.errores.fecha}
                                                />
                                            )}
                                        />
                                    </LocalizationProvider>
                                </Grid>

                                {/* Descripción */}
                                <Grid item xs={12}>
                                    <TextField
                                        label="Descripción"
                                        placeholder="Ingresa la descripción del evento"
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        value={this.state.txtDescripcion}
                                        onChange={(e) => this.setState({ txtDescripcion: e.target.value })}
                                        inputProps={{ maxLength: 500 }}
                                        error={!!this.state.errores.descripcion}
                                        helperText={this.state.errores.descripcion}
                                        fullWidth
                                    />
                                </Grid>

                                {/* Adjuntar archivo */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" sx={{ fontSize: '18px', mb: 1.5 }}>
                                        Selecciona un archivo
                                    </Typography>
                                    <Box
                                        sx={{
                                            backgroundColor: '#f5f5f5',
                                            p: 2,
                                            borderRadius: 2,
                                            mb: 2,
                                            border: '1px solid #ddd'
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                            Puedes adjuntar archivos con extensión <strong>.pdf, .jpg, .png, .jpeg, .mp4, .zip, .rar</strong>, 
                                            con un límite máximo de <strong>100MB</strong>.
                                        </Typography>
                                    </Box>
                                    <input
                                        accept=".pdf,.jpg,.png,.jpeg,.mp4,.zip,.rar"
                                        type="file"
                                        onChange={(e) => this.handleArchivoChange(e)}
                                        style={{ marginTop: 8 }}
                                    />
                                    {this.state.errores.archivo && (
                                        <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                            {this.state.errores.archivo}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>

                    {/* Botón y alerta */}
                    <CardActions sx={{ justifyContent: 'flex-end', px: 3 }}>
                        <Button
                            variant="contained"
                            onClick={this.btnAgregarTicketClick}
                            sx={{
                                backgroundColor: '#8CC63E',
                                color: '#fff',
                                '&:hover': { backgroundColor: '#7ab834' },
                                mt: 2
                            }}
                        >
                            Enviar Ticket
                        </Button>
                        <Snackbar
                            open={this.state.mostrarAlerta}
                            onClose={this.handleCloseAlert}
                            autoHideDuration={3000}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                            <Collapse in={this.state.mostrarAlerta}>
                                <Alert
                                    severity={this.state.severidadAlerta}
                                    onClose={this.handleCloseAlert}
                                    sx={{ mt: 4, width: '100%' }}
                                >
                                    <AlertTitle>{this.state.severidadAlerta.toUpperCase()}</AlertTitle>
                                    {this.state.mensajeAlerta}
                                </Alert>
                            </Collapse>
                        </Snackbar>
                    </CardActions>
                </Card>
            </Paper>
        </Box>
    );
}

}

export default TicketPage